<template>
  <div id="app">
    <div class="main-content">
      <nav v-if="showNavbar" class="navbar navbar-light" style="padding: 0px">
        <div
          class="container-fluid header"
          style="
            background-image: linear-gradient(to right, #cae9ff, #fafaf9);
            flex-direction: row;
          "
        >
          <div style="text-align: left">
            <p style="margin-bottom: 0px; font-weight: 600">Visite</p>
            <h5 style="font-weight: 600; color: #2f6787">São Lourenço</h5>
          </div>
          <div>
            <NavBar :showBackButton="showBackButton" :pageTitle="pageTitle" />
          </div>
        </div>
      </nav>
      <router-view />
    </div>

    <div class="container footer">
      <p style="color: white; margin-bottom: -0.8em">Visite</p>
      <h5 style="color: white; font-weight: 600">São Lourenço</h5>
      <span class="text-muted" style="color: white !important; font-size: 10px"
        >Copyright © 2024 Visite São Lourenço (Brasil/legal entity)</span
      >
    </div>
  </div>
</template>
<script>
import { computed, watch } from "vue";
import { useRouter } from "vue-router"; // Import useRouter from Vue Router
import NavBar from "@/components/NavBar.vue";

export default {
  components: {
    NavBar,
  },
  data() {
    return {
      showBackButton: false, // Set to true/false based on conditions
      pageTitle: "", // Set dynamically based on conditions
    };
  },
  setup() {
    const router = useRouter(); // Use useRouter to access the router instance
    // Define a computed property to determine whether to show the navbar
    const showNavbar = computed(() => {
      // Access the current route's meta field to determine whether to show the navbar
      return router.currentRoute.value.meta.showNavbar;
    });

    watch(router.currentRoute, (to) => {
      showNavbar.value = to.meta.showNavbar;
    });

    return { showNavbar };
  },
};
</script>
<style>
#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh; /* Ensure the app takes at least the full height of the viewport */
}

.main-content {
  flex-grow: 1; /* Make the main content grow to fill available space */
  padding-bottom: 50px; /* Adjust the padding to accommodate the height of the footer */
}

.footer {
  background-color: #10415e;
  text-align: center;
  line-height: 50px; /* Vertically center the text */
}

.header {
  display: flex;
  flex-direction: column;
  background-color: #cae9ff;
  padding-bottom: 2em;
  padding-left: 1.2em;
  padding-top: 1em;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

.mobile-nav {
  background: #f1f1f1;
  position: fixed;
  bottom: 0;
  height: 65px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;
  z-index: 1000;
}

.bloc-icon {
  display: flex;
  justify-content: center;
  align-items: center;
}

.bloc-icon img {
  width: 30px;
}

a {
  color: black;
}

nav a.router-link-exact-active {
  color: #00b8dd;
}
</style>
